import React, { type CSSProperties } from "react";
import { Transition } from "@headlessui/react";
import useResizeObserver from "use-resize-observer";

const CollapsibleTransition = ({
    children,
    show,
}: {
    children: React.ReactNode;
    show?: boolean;
}) => {
    const { ref, height } = useResizeObserver<HTMLDivElement>();
    return (
        <Transition
            show={show}
            className="transition-all duration-200 ease-out"
            enterFrom="max-h-0 opacity-0"
            enterTo={`max-h-[var(--panel-height)] opacity-100`}
            leaveFrom={`max-h-[var(--panel-height)] opacity-100`}
            leaveTo="max-h-0 opacity-0"
            style={
                {
                    "--panel-height": `${height}px`,
                } as CSSProperties
            }
        >
            <div ref={ref}>{children}</div>
        </Transition>
    );
};

export default CollapsibleTransition;
